/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "./qrequest";


class _Tutorial {
    complete(ident) {
        qreq.post('/api/tutorial/complete', { ident: ident }, j => {
            if (j.errorCode)
                console.log('Tutorial.complete', 'error', j.errorMessage);
        });
    }

    checkCompleted(ident, callback) {
        qreq.post('/api/tutorial/status', { ident: ident }, j => {
            if (j.item)
                callback(j.item.completed);
        });
    }
}

const Tutorial = new _Tutorial();

export default Tutorial;